export default "__VITE_ASSET__DXrEmI2W__"